import { render } from "./ErrorLoad.vue?vue&type=template&id=4f60489c&scoped=true&ts=true"
import script from "./ErrorLoad.vue?vue&type=script&lang=ts"
export * from "./ErrorLoad.vue?vue&type=script&lang=ts"

import "./ErrorLoad.vue?vue&type=style&index=0&id=4f60489c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f60489c"]])

export default __exports__